export default __webpack_public_path__ + "static/media/Ch_2020-1-1.b8a0c0b3.png";